module.exports = __webpack_public_path__ + "img/bg-proyectos-11.5c2a5719.png";